import React from 'react';
import styled from 'styled-components';
import { TableProps, message } from 'components';
import { AuthContext } from 'contexts';
import SearchTable from './SearchTable';
import { useContractsContext } from './ContractsContext';

const ContractsTable: React.FC = () => {
  const { auth } = React.useContext(AuthContext);

  const { contracts, total, loading, setPage, sort, setSort } =
    useContractsContext();

  const columns: TableProps['columns'] = ([
    {
      title: 'Product',
      dataIndex: 'contractRateLabel',
      key: 'contractRateLabel',
      width: 240,
      render: (contractRateLabel: string) => (
        <ReportTextContainer>{contractRateLabel}</ReportTextContainer>
      ),
    },
    {
      title: 'Reference Number',
      dataIndex: 'contractNumber',
      key: 'contractNumber',
      width: 140,
      render: (contractNumber: string) => (
        <ReportTextContainer>{contractNumber}</ReportTextContainer>
      ),
    },
    {
      title: 'Billing Model',
      dataIndex: 'productBillingModel',
      key: 'productBillingModel',
      width: 140,
      render: (productBillingModel: string) => (
        <ReportTextContainer>{productBillingModel}</ReportTextContainer>
      ),
    },
  ] as TableProps['columns'])!.filter(Boolean);

  return (
    <>
      {
        <SearchTable
          rowKey={record => record._id}
          columns={columns}
          loading={loading}
          dataSource={contracts ?? []}
          totalItems={total || 0}
        />
      }
    </>
  );
};

// #region Styled components

const ReportTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

// #endregion

export default ContractsTable;
